import { EventItem } from './types.ts';

export const INITIAL_EVENTS: EventItem[] = [
  {
    id: 'ev-1',
    title: 'Welcome & Registration Desk',
    start: '2026-09-28T09:00',
    end: '2026-09-28T13:00',
    location: 'Main University Hall',
    price: 0,
    fixedCost: 150,
    costPerPerson: 2,
    capacity: 250,
    organisers: 6,
    category: 'Social',
    fundingModel: 'stibet-free',
    stibetType: 'general',
    taxTier: 'none',
    description: 'Welcome new international students, distribute welcome bags, SIM cards, and student passes.',
  },
  {
    id: 'ev-2',
    title: 'City Center Campus Rally',
    start: '2026-09-28T14:00',
    end: '2026-09-28T17:30',
    location: 'Old Town Square',
    price: 0,
    fixedCost: 200,
    costPerPerson: 1.5,
    capacity: 150,
    organisers: 5,
    category: 'Culture',
    fundingModel: 'stibet-free',
    stibetType: 'general',
    taxTier: 'cultural',
    description: 'Interactive team rally around historic landmarks with prize challenges at key checkpoints.',
  },
  {
    id: 'ev-3',
    title: 'Flag Night Welcome Party',
    start: '2026-09-28T21:00',
    end: '2026-09-29T03:00',
    location: 'Club Metropolis',
    price: 8,
    fixedCost: 800,
    costPerPerson: 3,
    capacity: 350,
    organisers: 8,
    category: 'Drinking',
    fundingModel: 'self-funded',
    taxTier: 'alcohol',
    nonFundableCost: 400, // Alcohol & venue rental
    description: 'The official opening party! Bring your country flag or paint flag face masks.',
  },
  {
    id: 'ev-4',
    title: 'Academic Orientation & Survival Guide',
    start: '2026-09-29T10:30',
    end: '2026-09-29T12:30',
    location: 'Auditorium Maxima',
    price: 0,
    fixedCost: 50,
    costPerPerson: 0.5,
    capacity: 200,
    organisers: 3,
    category: 'Academic',
    fundingModel: 'external',
    externalFunding: 150,
    taxTier: 'none',
    description: 'Crucial session on course registration, grading systems, library access, and visa compliance.',
  },
  {
    id: 'ev-5',
    title: 'Traditional Cultural Dinner & Folk Dance',
    start: '2026-09-30T18:00',
    end: '2026-09-30T21:30',
    location: 'Student Dining Hall',
    price: 10,
    fixedCost: 600,
    costPerPerson: 10,
    capacity: 120,
    organisers: 4,
    category: 'Culture',
    fundingModel: 'stibet-partial',
    stibetType: 'general',
    taxTier: 'cultural',
    description: 'Sample local cuisine, learn traditional dances, and enjoy live folk music performances.',
  },
  {
    id: 'ev-6',
    title: 'Tandem Language Speed Meeting',
    start: '2026-10-01T16:00',
    end: '2026-10-01T18:30',
    location: 'Campus Student Cafe',
    price: 0,
    fixedCost: 80,
    costPerPerson: 2,
    capacity: 80,
    organisers: 3,
    category: 'Social',
    fundingModel: 'fully-free',
    taxTier: 'none',
    description: 'Find a language exchange partner in 5-minute rotating conversational rounds.',
  },
  {
    id: 'ev-7',
    title: 'Sunset Beach Sports & Volleyball',
    start: '2026-10-02T15:00',
    end: '2026-10-02T19:00',
    location: 'Riverside Beach Arena',
    price: 0,
    fixedCost: 120,
    costPerPerson: 1,
    capacity: 100,
    organisers: 4,
    category: 'Sports',
    fundingModel: 'stibet-free',
    stibetType: 'general',
    taxTier: 'none',
    description: 'Beach volleyball tournament, spikeball, frisbee, and relaxing music by the river.',
  },
  {
    id: 'ev-8',
    title: 'National Park Hiking Day Trip',
    start: '2026-10-03T08:30',
    end: '2026-10-03T18:00',
    location: 'Mountain Reserve (Bus Pick-up)',
    price: 12,
    fixedCost: 900,
    costPerPerson: 12,
    capacity: 90,
    organisers: 5,
    category: 'Trip',
    fundingModel: 'stibet-partial',
    stibetType: 'one-day-excursion',
    taxTier: 'cultural',
    description: 'Guided day trip into the scenic national park including bus transfer and packed lunch.',
  },
  {
    id: 'ev-9',
    title: 'International Food Festival',
    start: '2026-10-05T17:00',
    end: '2026-10-05T20:30',
    location: 'University Courtyard',
    price: 5,
    fixedCost: 350,
    costPerPerson: 4,
    capacity: 220,
    organisers: 6,
    category: 'Culture',
    fundingModel: 'stibet-partial',
    stibetType: 'general',
    taxTier: 'cultural',
    description: 'Students prepare dishes from home countries to share across international tasting booths.',
  },
  {
    id: 'ev-10',
    title: 'Retro 90s Pub Crawl',
    start: '2026-10-06T20:30',
    end: '2026-10-07T01:30',
    location: 'Meeting point: Central Station',
    price: 12,
    fixedCost: 300,
    costPerPerson: 6,
    capacity: 160,
    organisers: 7,
    category: 'Drinking',
    fundingModel: 'self-funded',
    taxTier: 'alcohol',
    nonFundableCost: 600, // Alcohol shots
    description: 'Explore 4 top local pubs with free welcome shots, vintage games, and 90s hits.',
  },
  {
    id: 'ev-11',
    title: 'Sustainable Living & Eco Workshop',
    start: '2026-10-07T14:00',
    end: '2026-10-07T16:00',
    location: 'Green Hub Seminar Room 2',
    price: 0,
    fixedCost: 100,
    costPerPerson: 3,
    capacity: 40,
    organisers: 2,
    category: 'Art',
    fundingModel: 'stibet-free',
    stibetType: 'general',
    taxTier: 'cultural',
    description: 'Tips for eco-friendly student living, recycling guides, and DIY upcycling activities.',
  },
  {
    id: 'ev-12',
    title: 'Historical Castle Guided Tour',
    start: '2026-10-09T11:00',
    end: '2026-10-09T14:30',
    location: 'Royal Castle Gates',
    price: 5,
    fixedCost: 250,
    costPerPerson: 5,
    capacity: 75,
    organisers: 3,
    category: 'Culture',
    fundingModel: 'stibet-partial',
    stibetType: 'one-day-excursion',
    taxTier: 'cultural',
    description: 'Private tour of medieval royal chambers, armor collection, and panoramic tower view.',
  },
  {
    id: 'ev-13',
    title: 'Farewell Gala & Certificate Night',
    start: '2026-10-11T19:00',
    end: '2026-10-12T00:30',
    location: 'Grand Ballroom Hotel Plaza',
    price: 18,
    fixedCost: 1400,
    costPerPerson: 12,
    capacity: 250,
    organisers: 8,
    category: 'Drinking',
    fundingModel: 'stibet-partial',
    stibetType: 'general',
    taxTier: 'alcohol',
    nonFundableCost: 800, // Alcohol drinks & venue booking
    description: 'Formal dinner, award ceremony, photo booth, and emotional farewell party closing O-Weeks 2026!',
  },
];

